var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGynae(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7501 16.4166C9.66673 16.4166 7.66673 15.5833 6.25006 14.1666C5.91673 13.8333 5.91673 13.3333 6.25006 13C6.58339 12.6666 7.08339 12.6666 7.41673 13C8.5834 14.1666 10.0834 14.8333 11.7501 14.8333C15.1667 14.8333 17.8334 12.0833 17.8334 8.74998C17.8334 5.41665 15.1667 2.49998 11.7501 2.49998C8.3334 2.49998 5.66673 5.24998 5.66673 8.58331C5.66673 9.58331 5.91673 10.5833 6.41673 11.5C6.66673 11.9166 6.50006 12.4166 6.08339 12.6666C5.66673 12.9166 5.16673 12.75 4.91673 12.3333C4.33339 11.25 4.00006 9.91665 4.00006 8.66665C4.00006 4.33331 7.50006 0.833313 11.7501 0.833313C16.0001 0.833313 19.5001 4.33331 19.5001 8.58331C19.5001 12.8333 16.0834 16.4166 11.7501 16.4166Z",
    fill: "#3A2CA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.00002 19.1666C1.75002 19.1666 1.58335 19.0833 1.41669 18.9166C1.08335 18.5833 1.08335 18.0833 1.41669 17.75L6.25002 12.9166C6.58335 12.5833 7.08335 12.5833 7.41669 12.9166C7.75002 13.25 7.75002 13.75 7.41669 14.0833L2.58335 18.9166C2.41669 19.0833 2.25002 19.1666 2.00002 19.1666Z",
    fill: "#3A2CA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 13.75C8.91663 13.75 6.66663 11.5 6.66663 8.58329C6.66663 5.66663 8.99996 3.41663 11.8333 3.41663C14.6666 3.41663 17 5.74996 17 8.58329C17 9.08329 16.6666 9.41663 16.1666 9.41663C15.6666 9.41663 15.3333 9.08329 15.3333 8.58329C15.3333 6.66663 13.75 5.08329 11.8333 5.08329C9.91663 5.08329 8.33329 6.66663 8.33329 8.58329C8.33329 10.5 9.91663 12.0833 11.8333 12.0833C13.1666 12.0833 14.4166 11.3333 15 10.0833C15.1666 9.66663 15.6666 9.49996 16.0833 9.66663C16.5 9.83329 16.6666 10.3333 16.5 10.75C15.5833 12.6666 13.75 13.75 11.75 13.75Z",
    fill: "#FF9A7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.41665 19.5833C6.16665 19.5833 5.99998 19.5 5.83331 19.3333L1.08331 14.5833C0.74998 14.25 0.74998 13.75 1.08331 13.4166C1.41665 13.0833 1.91665 13.0833 2.24998 13.4166L6.99998 18.1666C7.33331 18.5 7.33331 19 6.99998 19.3333C6.83331 19.5 6.66665 19.5833 6.41665 19.5833Z",
    fill: "#FF9A7B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.75,
    height: 18.75,
    fill: "white",
    transform: "translate(0.833313 0.833313)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGynae);
export default __webpack_public_path__ + "static/media/gynae.6961715eba2a4181bced2782860db122.svg";
export { ForwardRef as ReactComponent };